import {configuratorState} from "../../state";

const FormatFiltersData = (filtersSection) => {
  
  configuratorState.modelMaterialFilterMenus = filtersSection;
 
};

export default FormatFiltersData;
